export let Code = {
type: `@Component({
    selector: 'p-breadcrumb',
    template:
        <p-breadcrumb [model]="items" [home]="home"></p-breadcrumb>
})
export class Breadcrumb {
	this.items = [
	    {label:'Categories'},
	    {label:'Sports'},
	    {label:'Football'},
	    {label:'Countries'},
	    {label:'Spain'},
	    {label:'F.C. Barcelona'},
	    {label:'Squad'},
	    {label:'Lionel Messi', url: 'https://en.wikipedia.org/wiki/Lionel_Messi'}
	];

	this.home = {icon: 'fa ion-ios-home'};
}
`
};


// WEBPACK FOOTER //
// ./src/app/code/breadcrumb.ts